const Index = () => import("./index.vue");
const CreatePage = () => import("./_pages/create.vue");
const ViewPage = () => import("./_pages/view.vue");

export default [
  {
    path: "/currencies",
    component: Index,
  },
  {
    path: "/new-currency",
    component: CreatePage,
  },
  {
    path: "/currency/:id",
    component: ViewPage,
  },
];
